import type { Capability } from '@taler/api-client'

/** Every `ReceiptApi` method requires `RECORDS_MANAGE` server-side (`ReceiptService.kt`) - the
 * same reasoning as loans, contacts and targets: a receipt scan is a financial record, not an
 * accounting view, and the contract grants no dedicated capability to invent a narrower gate. */
export function canManageReceiptScans(can: (capability: Capability) => boolean): boolean {
  return can('RECORDS_MANAGE')
}
